import { asyncRouterMap, constantRouterMap } from '@/router/routerList'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
    if (route.meta && route.meta.permission) {
        let flag = false
        for (let i = 0, len = permission.length; i < len; i++) {
            flag = route.meta.permission.includes(permission[i])
            if (flag) {
                return true
            }
        }
        return false
    }
    return true
}

function filterAsyncRouter(routerMap, roles) {
    const accessedRouters = routerMap.filter(route => {
        if (hasPermission(roles, route)) {
            if (route.children && route.children.length) {
                route.children = deepAsyncRouter(route.children, roles)
            }
            return true
        }
        return false
    })
    return accessedRouters
}

function deepAsyncRouter(routeitem, roles) {
    const accessed = []
    roles.map(item => {
        let filRoute = routeitem.filter(route => {
            if (hasPermission([item], route)) {
                if (route.children && route.children.length) {
                    route.children = deepAsyncRouter(route.children, roles)
                }
                return true
            }
            return false
        })

        if (filRoute.length > 0) {
            accessed.push(...filRoute)
        }
    })
    return Array.from(new Set(accessed))
}

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: []
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers
            state.routers = constantRouterMap.concat(routers)
        }
    },
    actions: {
        GenerateRoutes({ commit }, data) {
            return new Promise(resolve => {
                const { roles } = data
                const accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
                commit('SET_ROUTERS', accessedRouters)
                resolve()
            })
        }
    }
}

export default permission
